import axios from "axios";
import {API_BASE_URL} from "../api/api";

export const getStoredAccessToken = () => localStorage.getItem("accessToken");
export const getStoredRefreshToken = () => localStorage.getItem("refreshToken");

export const storeTokens = (accessToken: string, refreshToken: string) => {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
};

export const clearTokens = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
};

export const refreshAccessToken = async (): Promise<string> => {
    const refreshToken = getStoredRefreshToken();
    if (!refreshToken) throw new Error("No refresh token found");

    const response = await axios.post(`${API_BASE_URL}/auth/refresh-token`, {
        refreshToken,
    });

    const { accessToken, refreshToken: newRefreshToken } = response.data;

    storeTokens(accessToken, newRefreshToken);
    return accessToken;
};
